export const validationMessages = {
  requiredField: "Pole wymagane",
  requiredRecaptchaField: "Uzupełnij checkbox weryfikacyjny",
  invalidEmail: "Niepoprawny format email",
  max500character: "Maksymalnie 500 znaków"
};
